import { ERROR_CODES } from '../errors/error-codes';
const KNOWN_ERROR_CODES = new Set(Object.values(ERROR_CODES));
/**
 * OKUMA hatasının metin anahtarı (liste/kulvar/panel yüklenemedi).
 *
 * Blok 19 QA P3-2: `statusCode === 0` istek sunucuya HİÇ ULAŞMADI demektir ve
 * istemci onu `INTERNAL_ERROR`a normalize eder. Yazma diyalogları bunu zaten
 * "bağlantı yok" diye yazıyordu (`meetingActionErrorKey`), okuma yüzeyleri ise
 * aynı koşulda "beklenmeyen bir hata" diyordu — aynı ağ kesintisi iki farklı
 * hata sınıfı gibi görünüyordu. Kural artık tek yerde.
 */
export function loadErrorKey(code, statusCode) {
    if (statusCode === 0)
        return 'common.errorOffline';
    if (!code || !KNOWN_ERROR_CODES.has(code)) {
        return `errors.${ERROR_CODES.INTERNAL_ERROR}`;
    }
    return `errors.${code}`;
}
/**
 * DAVET KABULÜNDE "ETKİNLİK DOLU" (kontenjan turu, 13.10.2026).
 *
 * Kabul ortak kayıt çekirdeğinden geçer (`createAttendanceTx`) ve dolu
 * etkinlikte üç ayrı 409 döner: etkinlik kapasitesi, bilet kontenjanı ya da
 * kredi tavanı. Davetli bilet türü seçmez ve tavanı bilmez (V17: tavan
 * katılımcıya sızmaz); üçü de onun için aynı olgudur. Kabul ekranları bu
 * kodlarda tek cümle yazar, diğer kodlarda ortak hata cümlesine düşer.
 */
export const INVITATION_FULL_ERROR_CODES = new Set([
    ERROR_CODES.EVENT_CAPACITY_EXCEEDED,
    ERROR_CODES.TICKET_QUOTA_EXCEEDED,
    ERROR_CODES.EVENT_ATTENDEE_CEILING_REACHED,
]);
export function isInvitationFullError(code) {
    return typeof code === 'string' && INVITATION_FULL_ERROR_CODES.has(code);
}
/** Davet kabul/ret hatasının metin anahtarı: dolu etkinlik kendi cümlesini alır. */
export function invitationDecisionErrorKey(code, statusCode) {
    if (statusCode !== 0 && isInvitationFullError(code))
        return 'invitations.acceptFull';
    return loadErrorKey(code, statusCode);
}
//# sourceMappingURL=error-text.js.map